<div class="mx-3 mb-2">
  <label class="form-label mb-2">Options</label>
  @for (optionCtrl of optionsCtrl.controls; track optionCtrl; let i = $index) {
    <div class="d-flex align-items-center mb-2">
      <mat-form-field appearance="outline" class="flex-grow-1 mx-2 mb-2">
        <input
          matInput
          [formControl]="optionCtrl"
          placeholder="Option {{ i + 1 }}"
          (keydown.enter)="$event.preventDefault()"
          />
      </mat-form-field>
      @if (optionsCtrl.length > 1) {
        <button
          mat-icon-button
          color="warn"
          type="button"
          (click)="removeOption(i)"
          aria-label="Remove option"
          [id]="getRemoveOptionButtonId(i)"
          class="remove-option-btn"
          >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  }
  <div class="d-flex align-items-center">
    <mat-form-field appearance="outline" class="flex-grow-1 mx-2 mb-2">
      <input
        matInput
        placeholder="Add option"
        [formControl]="newOptionControl"
        (keydown.enter)="$event.preventDefault(); addOption()"
        (blur)="$event.preventDefault(); addOption()"
        name="newOptionInput"
        [id]="getAddOptionInputId()"
        class="add-option-input"
        />
    </mat-form-field>
    <button
      mat-icon-button
      color="primary"
      type="button"
      (click)="addOption()"
      [disabled]="!newOptionControl.value || optionsCtrl.value.includes(newOptionControl.value)"
      aria-label="Add option"
      [id]="getAddOptionButtonId()"
      class="add-option-btn"
      >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
